import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import ReactTooltip from "react-tooltip";

import {
  getPartnerList,
  postCreatePartner,
  postDeletePartner,
  postUpdatePartner,
} from "../../../../apis/partnerShowcase";
import UploadIcon from "../../../../assets/icons/UploadIcon";
import Title from "../../../../components/common/Title";
import { isValidHttpsWebsite } from "../../../../functions";
import CreatePartner from "./CreatePartner";
import Information from "../../../../assets/images/information.png";

const PartnerShowCase = () => {
  const { eventId } = useParams();

  const [partnerList, setPartnerList] = useState([]);
  const [showCreatePartner, setShowCreatePartner] = useState(false);

  const callPartnerList = async () => {
    try {
      const { data } = await getPartnerList(eventId);
      setPartnerList(
        data.data.map((el) => {
          return {
            ...el,
            width: JSON.parse(el.meta_data).width,
            height: JSON.parse(el.meta_data).height,
          };
        })
      );
    } catch (error) {
      console.error(error);
      window.Toast.fire({
        title: "Something went wrong",
        icon: "error",
      });
    }
  };

  const onSave = async (webLink, image, metadata, id) => {
    if (webLink && !isValidHttpsWebsite(webLink)) {
      window.Toast.fire({
        icon: "error",
        title: "Please add a proper redirect url",
      });
      return false;
    }
    if (!image) {
      window.Toast.fire({
        icon: "error",
        title: "Please fill all the fields",
      });
      return false;
    }
    if (id) {
      try {
        const payload = {
          event_id: eventId,
          url: image,
          link: webLink,
          is_video: metadata.isVideo,
          width: metadata.width,
          height: metadata.height,
          id: id,
        };
        await postUpdatePartner(payload);
        window.Toast.fire({
          icon: "success",
          title: "Brand media updated successfully",
        });

        const cloneOfList = structuredClone(partnerList);
        const index = cloneOfList.findIndex((el) => el.id === id);
        if (index > -1) {
          const newEntry = {
            url: image,
            link: webLink,
            is_video: metadata.isVideo,
            id: id,
            width: metadata.width,
            height: metadata.height,
          };
          cloneOfList[index] = newEntry;
          setPartnerList(cloneOfList);
          setShowCreatePartner(false);
        }
      } catch (error) {
        console.error(error);
        window.Toast.fire({ icon: "error", title: "Something went wrong" });
        callPartnerList();
        return false;
      }
    } else {
      try {
        const payload = {
          event_id: eventId,
          url: image,
          link: webLink,
          is_video: metadata.isVideo,
          width: metadata.width,
          height: metadata.height,
        };
        const { data } = await postCreatePartner(payload);
        window.Toast.fire({
          icon: "success",
          title: "Brand media added successfully",
        });
        setPartnerList((prev) => [
          ...prev,
          {
            url: image,
            link: webLink,

            is_video: metadata.isVideo,
            id: data.data.id,
            width: metadata.width,
            height: metadata.height,
          },
        ]);
        setShowCreatePartner(false);
      } catch (error) {
        console.error(error);
        window.Toast.fire({ icon: "error", title: "Something went wrong" });
        callPartnerList();
        return false;
      }
    }
  };

  const onRemove = async (id) => {
    try {
      const payload = {
        event_id: eventId,
        id: id,
      };
      await postDeletePartner(payload);
      window.Toast.fire({
        icon: "success",
        title: "Brand media deleted successfully",
      });
      if (partnerList.length === 1) {
        setPartnerList([]);
        return;
      }
      const cloneOfList = structuredClone(partnerList);
      const index = cloneOfList.findIndex((el) => el.id === id);
      if (index > -1) {
        cloneOfList.splice(index, 1);
        setPartnerList(cloneOfList);
      }
    } catch (error) {
      console.error(error);
      window.Toast.fire({ icon: "error", title: "Something went wrong" });
      callPartnerList();
      return false;
    }
  };

  useEffect(() => {
    callPartnerList();
  }, []);

  return (
    <div>
      <Title
        className="pb-4 mb-6 border-b border-secondary-600 mt-4"
        text={
          <>
            <div>Brand Showcase</div>{" "}
            <span
              className="pl-3 cursor-pointer relative"
              data-tip
              data-for="partnerShowcaseTip"
            >
              <img className="cursor-pointer" src={Information} />
              <ReactTooltip
                id="partnerShowcaseTip"
                multiline={true}
                type="dark"
                className="z-[100] !opacity-100"
              >
                <div>
                  <h3 className="text-xl font-medium mb-1">Feature Overview</h3>
                  <ul className="list-disc px-4 mb-2 text-sm">
                    <li>
                      The Brand Showcase feature allows brands to display their
                      ads between event images
                    </li>
                  </ul>
                  <div className="w-full mt-2 mb-2 h-[1px] bg-[#555555]"></div>
                  <h3 className="text-xl font-medium mb-1">How to use</h3>
                  <ol className="list-decimal px-4 mb-2 text-sm">
                    <li>
                      Click 'Upload brand media' to upload the png,gif or mp4
                      files .<li>Add a hyperlink (if needed).</li>
                      <li>Click on tick mark.</li>
                    </li>
                  </ol>
                  <video
                    muted
                    autoPlay
                    loop
                    playsinline
                    src={
                      "https://img2.pixnif.com/assets/videos/brandshowcase.mov"
                    }
                    height={400}
                    width={400}
                  />
                </div>
              </ReactTooltip>
            </span>
          </>
        }
      />

      {partnerList.length ? (
        partnerList.map((el) => (
          <div key={el.id}>
            <CreatePartner
              onSave={onSave}
              onRemove={onRemove}
              mediaIsVideo={el.is_video}
              id={el.id}
              imageUrl={el.url}
              websiteLink={el.link}
              width={el.width}
              height={el.height}
            />
          </div>
        ))
      ) : (
        <></>
      )}

      {showCreatePartner ? (
        <div className="my-8">
          <CreatePartner
            onSave={onSave}
            onCancel={() => setShowCreatePartner(false)}
            openUploadPopUp
          />
        </div>
      ) : (
        <></>
      )}

      <button
        title="Add brand media"
        className={`font-medium mt-4 cursor-pointer !bg-dark-gray flex gap-4 items-center rounded-xl shadow-card  px-3 py-2.5 w-fit`}
        onClick={() => {
          if (showCreatePartner) {
            window.Toast.fire({
              icon: "error",
              title: "Editing of other brand media is going on",
            });
            return;
          }
          setShowCreatePartner(true);
        }}
      >
        <UploadIcon color="#00b7b8" /> Upload brand media
      </button>
    </div>
  );
};

export default PartnerShowCase;
